module.exports = __webpack_public_path__ + "static/1333708460-exit.b28ea994.jpg";